import { Separator } from '@/components/ui/separator.tsx';
import { BannerUserInfos } from '@/components/custom';
import { IBioVerification } from '@/lib/interface.ts';
import { CardHeader } from '@/components/ui';

type TProps = {
	item: IBioVerification;
};

const BioVerificationItemHeader = ({ item }: TProps) => (
	<CardHeader className={'p-0'}>
		<BannerUserInfos
			enableClickToRedirectToProfile
			className='px-4 pt-3'
			user={item.userData}
			hideEmail />
		<div className='py-1'>
			<Separator />
		</div>
		<p className={`text-sm text-muted-foreground px-4 pb-4`}>
			{item.aboutYou}
		</p>
	</CardHeader>
);

export default BioVerificationItemHeader;
